import {getMediaAssetProps} from '~/cms/helpers/getMediaAssetProps'
import {
  type HgArticleWYSIWYGMediaAssetProps,
  type HgArticleWYSIWYGMediaGridProps,
  HgArticleWYSIWYGMediaGrid,
} from '~/design-system/hg/components/HgWYSIWYG/Article/_components'
import {wysiwygComponentVariants} from '../../_utils/variants'
import {type WysiwygMediaGridFragment} from './_generated/fragment.graphql'

type DatoWYSIWYGMediaGridProps = WysiwygMediaGridFragment & {
  openLightbox: NonNullable<HgArticleWYSIWYGMediaAssetProps['openLightbox']>
}

export const DatoWYSIWYGMediaGrid = ({
  assets,
  size,
  openLightbox,
}: DatoWYSIWYGMediaGridProps) => {
  const mediaAssets = assets.map(asset => ({
    ...getMediaAssetProps(asset),
    openLightbox,
  })) as HgArticleWYSIWYGMediaGridProps['assets']
  const mediaGridSize = size as HgArticleWYSIWYGMediaGridProps['size']

  const {mediaGrid} = wysiwygComponentVariants({
    mediaGridSize,
    mediaGridNumberOfAssets: mediaAssets.length,
  })

  return (
    <HgArticleWYSIWYGMediaGrid
      className={mediaGrid()}
      assets={mediaAssets}
      size={mediaGridSize}
    />
  )
}
